// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1MtL0","rootCenter":"LoadMoreObserver_rootCenter__21jMd","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3OFG1"};